import { useEffect, useReducer } from 'react';
import { getUserFromReferralCode } from '../models/user';
import pricingConstants from '../utils/constants/pricing';
import referralConstants from '../utils/constants/referral';

const initialState = {
  referrer: null,
  loading: true,
  error: null,
  pricing: pricingConstants.PRICING_DEFAULT,
};

function reducer(state, action) {
  switch (action.type) {
    case 'setReferrer':
      return { ...state, ...action.data };
    case 'setLoading':
      return { ...state, loading: action.data };
    default:
      return state;
  }
}

// Referral plans sit on the standard yearly base but are never part of the
// yearly price experiment: the referrer promises a specific deal to the person
// they refer, and that should not change on a dice roll. So they move only when
// the base moves and someone moves them — $69.99 to $89.99 in PROD-4565 and
// PROD-4700, and $89.99 to $99.99 here in PROD-6193 after webYearlyPricing2's
// arm a won.
export function getPricingForReferral(referralType) {
  if (referralType === referralConstants.TYPE_REFERRAL_SUBSCRIPTION_14TRIAL) {
    return pricingConstants.PRICING_REFERRAL_9999_14T;
  }
  if (
    [
      referralConstants.TYPE_USER_SUBSCRIPTION_7TRIAL,
      referralConstants.TYPE_CELEBRITY_SUBSCRIPTION,
    ].includes(referralType)
  ) {
    return pricingConstants.PRICING_YEARLY_9999_7DAYS_REFERRAL;
  }
  if (
    referralType === referralConstants.TYPE_INFLUENCER_SUBSCRIPTION_25OFF_7TRIAL
  ) {
    return pricingConstants.PRICING_YEARLY_9999_7DAYS_25OFF;
  }
  return pricingConstants.PRICING_REFERRAL_9999_30T;
}

export async function getReferralDetails({
  referralCode,
  referralType,
  getReferralType,
  allowAuraSocial,
}) {
  let referral = {};
  const referrer = await getUserFromReferralCode(referralCode);
  const referralTypeResult = referralType || (await getReferralType(referrer));
  if (referrer) {
    referral = {
      referrer: {
        ...referrer,
        referralCode,
        referralType: referralTypeResult,
      },
      error: false,
      pricing: getPricingForReferral(referralTypeResult),
    };
  } else if (
    referralCode === referralConstants.REFER_CODE_AURA_SOCIAL &&
    allowAuraSocial
  ) {
    referral = {
      referrer: {
        referralCode,
      },
      pricing: getPricingForReferral(referralTypeResult),
    };
  } else {
    referral = {
      referrer: null,
      error: true,
    };
  }
  return referral;
}

export default function useReferral(
  referralCode,
  referralType = referralConstants.TYPE_AMBASSADOR_30DAYS
) {
  const [referral, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (
      !referralCode ||
      referralCode === referralConstants.REFER_CODE_AURA_SOCIAL
    ) {
      dispatch({
        type: 'setLoading',
        data: false,
      });
      return;
    }
    dispatch({ type: 'setLoading', data: true });
    getReferralDetails({ referralCode, referralType }).then((referralData) => {
      dispatch({
        type: 'setReferrer',
        data: { ...referralData, loading: false },
      });
    });
  }, [referralCode, referralType]);
  return referral;
}
